import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-152" data-mp="1n00ra3zw93vo">
      <Reveal className="mx-auto max-w-6xl" data-id="element-153" data-mp="1mzisp0predkl">
        <div className="mb-12 text-center" data-id="element-154" data-mp="1r1dvyar93110">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-155" data-mp="1r02r07m2jn8b">SCELTO DAGLI INSEGNANTI</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-156" data-mp="1d0jkfj8wojy4">
            Cosa dicono gli insegnanti di matematica.
          </h2>
          <p className="mt-4 font-semibold text-brand-gray" data-id="element-157" data-mp="141od23u4l3t8">
            Pensato per insegnare la matematica con calma e sicurezza.
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-158" data-mp="184uhr71lamxl">
          {testimonials.map(({
          quote,
          name,
          role
        }) => <article key={name} className="flex min-h-[220px] flex-col rounded-2xl border border-brand-dark bg-brand-main p-7" data-id="element-159" data-mp="32gizfgz7h3lo">
              <div className="flex gap-1" data-id="element-160" data-mp="2uzhr9a8l2ycs">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-161" data-mp="2q27vlculpqgi" />)}
              </div>
              <p className="mt-5 font-serif text-lg italic leading-relaxed" data-id="element-162" data-mp="2zrrg0mxypsdh">{quote}</p>
              <div className="mt-auto pt-6" data-id="element-163" data-mp="2c2gjjhnnak55">
                <p className="text-sm font-bold text-brand-blue" data-id="element-164" data-mp="2c38gowww4pxj">{name}</p>
                <p className="text-xs text-brand-gray" data-id="element-165" data-mp="274ezatehges3">{role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}